import * as AuctionType from './type'

/**
 * auction store init state
 */
export const initAuctionState: AuctionType.AuctionState = {
  auctions: [],
}
